import { AsyncState, loadingAsyncState, unloadedAsyncState } from "widgets-for-react"
import { getCollectionPage } from "../../../../custom_api/api"
import { AdviceFilter } from "../../../../custom_api/bookarang/types"
import { fetchLocationPrompts } from "../../../../custom_api/collection/api"
import { WiseBook } from "../../../../custom_api/wise/types"
import { CollectionPageProps } from "../../../pages/collection_page"

export interface LocationBasedInspirationState {
  collectionPage: AsyncState<CollectionPageProps>
  prompts: AsyncState<string[]>
  searchTerm: string
  searchResults: string[]
  selectedPrompt: string
  advice: AsyncState<WiseBook[]>
  filters: AsyncState<AdviceFilter[]>
  routePath: string
  isKioskMode: boolean
}

export const initialLocationBasedState: LocationBasedInspirationState = {
  collectionPage: loadingAsyncState(() => getCollectionPage()),
  prompts: loadingAsyncState(fetchLocationPrompts),
  searchTerm: "",
  searchResults: [],
  selectedPrompt: null,
  advice: unloadedAsyncState(),
  filters: unloadedAsyncState(),
  routePath: '',
  isKioskMode: false
}

export type LocationBasedInspirationLayoutProps = LocationBasedInspirationState & {
  updateSearchTerm: (query: string) => void
}